package songwritersnotebook.app.components

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.Logout
import androidx.compose.material.icons.filled.AccountCircle
import androidx.compose.material.icons.filled.Person
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import songwritersnotebook.app.viewmodels.MainViewModel

@Composable
fun UserAccountHeader(
    mainViewModel: MainViewModel,
    onSignIn: () -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(64.dp)
            .padding(horizontal = 16.dp),
        contentAlignment = Alignment.CenterEnd
    ) {
        UserAccountMenu(mainViewModel, onSignIn)
    }
}

@Composable
fun UserAccountMenu(
    mainViewModel: MainViewModel,
    onSignIn: () -> Unit
) {
    val user by mainViewModel.currentUser.collectAsState()
    val userProfile by mainViewModel.userProfile.collectAsState()
    var showMenu by remember { mutableStateOf(false) }

    if (user == null) {
        Button(
            onClick = onSignIn,
            shape = CircleShape,
            contentPadding = PaddingValues(horizontal = 16.dp, vertical = 8.dp)
        ) {
            Icon(Icons.Default.Person, null, modifier = Modifier.size(18.dp))
            Spacer(Modifier.width(8.dp))
            Text("Sign In", fontSize = 14.sp)
        }
    } else {
        Box {
            IconButton(onClick = { showMenu = true }) {
                Icon(
                    Icons.Default.AccountCircle, 
                    contentDescription = "Profile",
                    modifier = Modifier.size(32.dp),
                    tint = MaterialTheme.colorScheme.primary
                )
            }

            DropdownMenu(
                expanded = showMenu,
                onDismissRequest = { showMenu = false }
            ) {
                DropdownMenuItem(
                    text = {
                        Column {
                            Text(userProfile?.username ?: "User", fontWeight = androidx.compose.ui.text.font.FontWeight.Bold)
                            Text(user?.email ?: "", style = MaterialTheme.typography.bodySmall)
                        }
                    },
                    onClick = { },
                    enabled = false
                )
                HorizontalDivider()
                DropdownMenuItem(
                    text = { Text("Sign Out") },
                    onClick = {
                        showMenu = false
                        mainViewModel.signOut()
                    },
                    leadingIcon = { Icon(Icons.AutoMirrored.Filled.Logout, null) }
                )
            }
        }
    }
}
